import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=5a68e85b"
import script from "./vipList.vue?vue&type=script&lang=js"
export * from "./vipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports